import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { PayoffVinResponse } from '../../shared/models/payoffVinResponse';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { AssetListResponse } from '../../shared/models/assetListResponse';
import { VinResponse } from '../../shared/vinResponse';
import { PayoffResponseBeanList } from '../../shared/payoffResponseBeanList';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { AddressRequest } from '../../shared/models/AddressRequest';
import { VertexAddressRequest } from '../../shared/models/VertexAddressRequest';
import { VertexAddressResponse } from '../../shared/models/VertexAddressResponse';
import { VertexAddressArrayResponse } from '../../shared/models/VertexAddressArrayResponse';
import { VertexPostalAddress } from '../../shared/models/VertexPostalAddress';
import { AccountNumberRequest } from '../../shared/models/accountNumberResponse';
import { Console } from 'console';
import { VinDetailsResponse } from '../../shared/models/VinDetailsResponse';
import { AccountNumber } from '../../shared/models/accountNumber';
import { DTFPayoffService } from './payoff.service';
import { from } from 'rxjs';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import { viewPayOffListLive } from '../../shared/models/viewPayOffListLive';
import { TerminationQuoteIdentifier } from '../../shared/models/TerminationQuoteIdentifier';
import { switchMap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
 
export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
}

interface Account {
  value: string;
  viewValue: string;
  viewValueFR: string;
}



@Component({
    selector: 'div.dtf-payoff',
    imports: [SharedTranslateModule,SessionTimeoutComponent,
        MatPaginator, MatSort, MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatNativeDateModule,
        MatDatepickerModule, MatIconModule, MatDialogModule, MatButtonModule, MatSortModule
    ],
    templateUrl: './payoff.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})



export class PayoffComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  password2 = '';
  password3 = '';
  loanAccounts = false;
  reTypePassword = '';
  token: string;
  brandId: string;
  action = '';
  loginAttempt = false;
  isLoginattempt = '';
  payoffAccount = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  currentPassword = '';
  emailAddress = '';
  currentPasswordDBCheckFlag = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  thirdParty: string;
  customerName: string;
  quoteCreatedOn:String;
  bodyLoaded = false;
  isFromAccount = true;
  disabledFlag = false;
  tableLoaded = true;
  dbLoaded = false;
  isFrench = false;
  openLoginModal = false;
  hideSingleSelectionIndicator=true;
  serviceErrorOccurred = false;
  contractSelected = false;
  vinSelected = false;
  OpenTitleAuth = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  ciamId = sessionStorage.getItem('loginID');
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  toggleEnum = ToggleEnum;
  selectedState = 0;
  SelectContract = false;
  viewpayoff = false;
  isInquiry = false;
  SelectAsset = false;
  enablePayoffQuote = false;
  enableVinPayoff = false;
  enableAssetPayoffQuote = false;
  disableDashboard = false;
  displayPayNow = false;
  isPositive = false;
  terminationDate = '';
  vinType = '';
  payoffVinRes: PayoffVinResponse[];
  accountDetailsRes: AccoutDetailsResponse[];
  accountDetails: AccoutDetailsResponse[];
  contractNumberList: ContractNumberRequest[];
  titleAuthNumberList: ContractNumberRequest[];
  addressRequest: AddressRequest;
  addressRequestList: AddressRequest[];
  titleAuthNumberAccountList: AccountNumberRequest[];
  displaycontractNumberList = '';
  displayaccountNumberList = '';
  displayVinList = '';
  vinListForPdfTable = ''
  assetTotal = 0;
  payoffTotal = 0;
  assetListRequest: AssetListResponse[];
  assetListRes: AssetListResponse[];
  contract: ContractNumberRequest;
  account: AccountNumberRequest;
  // viewPayoffList: viewPayOffList[];
  ViewPayOffListLive: viewPayOffListLive[];
  vinDetailsRes: VinDetailsResponse[];
  AccountNbr: string;
  tempAssetListResponse: AssetListResponse;
  tempVinResponse: VinResponse;
  vinResponse: VinResponse[];
  vinResponseList: VinResponse[];
  payoffResponseBeanList: PayoffResponseBeanList[];
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);
  selectionsingle = new SelectionModel<AccoutDetailsResponse>(false, []);
  selection2 = new SelectionModel<AssetListResponse>(true, []);
  selectedAccount: AccountNumber;
  selectedAccountList: AccountNumber[];
  getAgreementAssetDetailRequest: any = {};
  getMultiPayoffRequest: any = {};
  getTitleAuthorizationRequest: any = {};
  status: string = '';
  //accountNum: string = '';
  amount: string = '';
  minDate: Date;
  maxDate: Date;
  selectedDate: Date;
  PaymentTime: string;
  recipientForm: FormGroup;
  name: string;
  address: string;
  address2: string;
  payoffAddress: string;
  payoffAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  prefill = true;
  // frombackbuttom=false;
  quotationNo: number;
  selectedValue: string = '';
  isVin = false;
  ifVin = false;
  inputValue: string = ''; 
  isVinPayoff = false;
  invalid = false;
  required = false;
  error = false;
  MoreAccountsFlow = false;
  DTPAY = true;

  accounts: Account[] = [
    {value: 'byAccount', viewValue: 'Payoff By Account(s)', viewValueFR: 'Remboursement par compte(s)'},
    {value: 'byAsset', viewValue: 'Payoff By Asset(s)', viewValueFR: 'Remboursement par actif(s)'},
    {value: 'byVin', viewValue: 'Payoff By VIN', viewValueFR: 'Remboursement par NIV'},
    {value: 'ForAccount', viewValue: 'Balance Inquiry For Account(s)', viewValueFR: 'Demande de solde pour compte(s)'},
    {value: 'ForAsset', viewValue: 'Balance Inquiry For Asset(s)', viewValueFR: 'Demande de solde pour actif(s)'}
  ];
  accountsForUs: Account[] = [
    {value: 'byAccount', viewValue: 'Payoff By Account(s)', viewValueFR: 'Remboursement par compte(s)'},
    {value: 'byAsset', viewValue: 'Payoff By Asset(s)', viewValueFR: 'Remboursement par actif(s)'},
    {value: 'ForAccount', viewValue: 'Balance Inquiry For Account(s)', viewValueFR: 'Demande de solde pour compte(s)'},
    {value: 'ForAsset', viewValue: 'Balance Inquiry For Asset(s)', viewValueFR: 'Demande de solde pour actif(s)'}
  ];
  stateLabelValues = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
  ];
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Account',
      displayFR: 'Numéro de compte',
      dispFormat: ''
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier versement',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Account Type',
      displayFR: 'Type de compte',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date d\'échéance',
      dispFormat: ''
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);


  initVinColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'agreementNum',
      display: 'Account',
      displayFR: 'Numéro de compte',
      dispFormat: ''
    },
    {
      name: 'vinNum',
      display: 'Vin Number',
      displayFR: 'NIV',
      dispFormat: ''
    },
  ];
  displayedVinColumns: any[] = this.initVinColumns.map(col => col.name);

  vininitColumns: any[] = [
    {
      name: 'vinNum',
      display: 'Asset Serial Number',
      dispFormat: ''
    }
  ];
  vindisplayedColumns: any[] = this.vininitColumns.map(col => col.name);

  initViewPayoffColumns: any[] = [
    // {
    //   name: 'checkbox',
    //   display: '',
    //   displayMobile: '',
    //   displayFR: '',
    //   dispFormat: 'checkbox'
    // },
    {
      name: 'expandicon',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: 'expandicon'
    },
    {
      name: 'agreementNumber',
      display: 'Account Number',
      displayFR: 'Compte',
      dispFormat: 'acct'
    },
    {
      name: 'status',
      display: 'Status',
      displayFR: 'Statut',
      dispFormat: ''
    },
    {
      name: 'quotationNumber',
      display: 'Quote Number',
      displayFR: 'Numéro de devis',
      dispFormat: 'quoteNum'
    },
    {
      name: 'pdf',
      display: '',
      dispFormat: 'pdf'
    }, 
    {
      name: 'amount',
      display: 'Payoff Amount',
      displayFR: 'Montant du remboursement',
      dispFormat: 'currency'
    },	
    {
      name: 'dateTime',
      display: 'Payoff Request',
      displayFR: 'Demande de remboursement',
      dispFormat: 'date1'
    },
    {
      name: 'goodThrough',
      display: 'Good Through',
      displayFR: 'Valide jusqu’au',
      dispFormat: 'date'
    },
    {
      name: 'numberOfAssets',
      display: 'Asset Count',
      displayFR: 'Nombre d’actifs',
      dispFormat: ''
    },
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: 'pay'
    }
  ];
  displayedViewPayoffColumns: any[] = this.initViewPayoffColumns.map(col => col.name);

  initMultiPayoffColumns: any[] = [
    {
      name: 'contractNumber',
      display: 'Account',
      displayFR: 'Numéro de compte',
      dispFormat: ''
    },
    {
      name: 'quoteNumber',
      display: 'Quote Number',
      displayFR: 'Cite nombre',
      dispFormat: ''
    },
    {
      name: 'quoteAmount',
      display: 'Quote Amount',
      displayFR: 'Montant total dû',
      dispFormat: 'currency'
    },
    {
      name: 'quoteCreatedTimestamp',
      display: 'Quote Created',
      displayMobile: '',
      displayFR: 'NIV',
      dispFormat: ''
    },
    {
      name: 'qtBuyOutDt',
      display: 'Good Through',
      displayFR: 'Date d\'expiration',
      dispFormat: 'date'
    },
    {
      name: 'terminatedAssetsCount',
      display: 'Asset Count',
      displayFR: 'Nombre d\'actifs',
      dispFormat: ''
    },
    {
      name: 'vinNum',
      display: 'VIN',
      displayMobile: '',
      displayFR: 'NIV',
      dispFormat: ''
    },
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: 'pay'
    }
  ];
  displayedMultiPayoffColumns: any[] = this.initMultiPayoffColumns.map(col => col.name);


  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';


  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  vinDataSource: MatTableDataSource<AssetListResponse>;
  vinDataSource1: MatTableDataSource<VinDetailsResponse>;
  multipayoffdataSource: MatTableDataSource<PayoffResponseBeanList>;
 // viewpayoffdataSource: MatTableDataSource<viewPayOffList>;
  listLiveAndExpiredQuotesdataSource: MatTableDataSource<viewPayOffListLive>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;



  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog, private service: DTFPayoffService,private cdRef: ChangeDetectorRef,

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    //this.accountDetailsRes = [];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
    this.assetListRes = [];
    //this.viewPayoffList= [];
    this.ViewPayOffListLive = [];
    this.listLiveAndExpiredQuotesdataSource = new MatTableDataSource(this.ViewPayOffListLive);
    this.assetListRequest = [];
    this.payoffVinRes = [];
    this.vinResponseList = [];
    this.vinDataSource = new MatTableDataSource(this.assetListRes);
    this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
   // this.viewpayoffdataSource = new MatTableDataSource(this.viewPayoffList);

    this.minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 30);
  }

  ngAfterViewInit() {
  }

  restrictSpecialChars(event: KeyboardEvent): void {
    const key = event.key;
    
    // Check if the entered key is a special character
    const isSpecialChar = /[^a-zA-Z0-9]/.test(key);

    if (isSpecialChar) {
      event.preventDefault();  // Prevent entering the special character
    }
  }

  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }
  SetTitleAuth(event: Event) {
    sessionStorage.removeItem('addressValid');
    if (!this.isInquiry) {
      if (!this.name) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidName').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else if (!this.address) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidAddess').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else if (!this.city) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidCity').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else if (!this.state) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidState').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else if (!this.zipCode) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidZip').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else if (!this.selectedDate) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidGoodThroughDt').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else {
        // this.titleAuthForm(); //move
        if (this.prefill) {
          this.titleAuthForm();
        }
        else {
          this.vertexCall();
        }
      }
    }
    else {
      if (!this.selectedDate) {
        sessionStorage.setItem('payoffdialog', 'error');
        this.translate.get('Payoff.InvalidGoodThroughDt').subscribe((data: any) => {
          this.auth.SetErrorMessage(data);
        });
        this.openDialog(5);
      }
      else {
        // this.vertexCall();
        this.titleAuthForm();
      }
    }
  }

  _keyUp(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.key);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  SubmitTitleAuth() {
    const titleAuthorizationRequest = {
      contractNumberList: this.titleAuthNumberList,
      recipientName: this.name,
      recipientAddress1: this.address,
      recipientAddress2: this.address2,
      recipientState: this.state,
      recipientCity: this.city,
      recipientZipCode: this.zipCode,
      ciamId: this.ciamId,
    };

    this.auth.setTitleAuthorization(titleAuthorizationRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        // this.openDialog(1);
      }
      else {
        sessionStorage.setItem('payoffdialog', 'error');
        this.auth.SetErrorMessage('An Error Has Occured');
        this.openDialog(5);
        // If checks to load BE error messages based on language
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000);  //2s
        this.disabledFlag = false;
        this.tableLoaded = true;
        this.cdRef.detectChanges();
      }
    });

  }
  applyVinFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.vinDataSource.filter = filterValue.trim().toLowerCase();
    if (this.vinDataSource.paginator) {
      this.vinDataSource.paginator.firstPage();
    }
    this.rowCount = this.vinDataSource.filteredData.length;
  }

  applyviewpayoffFilter(input: string) {

    this.listLiveAndExpiredQuotesdataSource.filterPredicate = (data: viewPayOffListLive, f: string) =>
      !f ||
      data.agreementNumber.toLowerCase().includes(f) ||
      data.status.toLowerCase().includes(f.toLowerCase());
    input = input.trim(); // Remove whitespace
    input = input.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.listLiveAndExpiredQuotesdataSource.filter = input;
    if (this.listLiveAndExpiredQuotesdataSource.paginator) {
      this.listLiveAndExpiredQuotesdataSource.paginator.firstPage();
    }
    this.rowCount = this.listLiveAndExpiredQuotesdataSource.filteredData.length;


 
  }


  onAccountRedirect(num: number) {
   
    //Turn on booleans
    this.bodyLoaded = false;
    if (num === 1) {
      this.SelectContract = false;
      this.OpenTitleAuth = false;
      if (this.isCanadaPortal) {
        this.isInquiry = true;
      }
      else {
        this.isInquiry = false;
      }
      this.selectedValue = "byAsset";
      this.getAccountDetailsListByUserId();
    }
    else {
      //manipulate the function
      for (var i = 0; i < this.accountDetailsRes.length; i++) {
        if (this.accountDetailsRes[i].contractNum === this.payoffAccount) {
          //set Contract for function redirect
          this.contractNumberList = [];
          this.contractSelected = true;
          this.contract = new ContractNumberRequest();
          this.contract.contractNumber = this.accountDetailsRes[i].contractNum.slice(0, -3);
          this.contract.scheduleNumber = 1;
          this.contract.contractType = this.accountDetailsRes[i].contractType;
          this.contract.onlinePayFlag = this.accountDetailsRes[i].onlinePayFlag;
          this.contractNumberList.push(this.contract);
        }
      }

      this.contractSelected = true;
      this.openVinPayoff();
    }

  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.isInquiry = false;
    this.SelectContract = false;
    this.OpenTitleAuth = false;
    this.SelectAsset = false;
    this.viewpayoff = false;
    this.selectedState = $event.value;
    this.getAccountDetailsListByUserId();
    if (this.selectedState === 1) {
      this.SelectContract = true;
      this.isInquiry = false;
      this.viewpayoff = false;
    }
    if (this.selectedState === 2) {
      this.SelectAsset = true;
      this.isInquiry = false;
      this.viewpayoff = false;
    }
    if (this.selectedState === 3) {
      this.SelectContract = true;
      this.isInquiry = true;
      this.viewpayoff = false;
    }

    if (this.selectedState === 5) {
      this.viewpayoff = true;
      this.SelectAsset = false;
      this.isInquiry = false;
      this.SelectContract = true;
    }
    if (this.selectedState === 4) {
      this.SelectAsset = true;
      this.isInquiry = true;
      this.viewpayoff = false;
    }


    return this.dataSource;
  }

  ngOnInit() {
    this.DtpayToggle();
    this.token = sessionStorage.getItem('ciamToken');
    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
    this.recAccCount = sessionStorage.getItem('recAccCount');

    this.getAccountDetailsListByUserId();


    this.payoffAccount = sessionStorage.getItem('amortAccount');
    sessionStorage.removeItem('amortAccount');
    sessionStorage.removeItem('payoffdialog');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.customerName = sessionStorage.getItem('customerName');
    this.language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = this.language;
    this.brandId = sessionStorage.getItem('brandId');
 
    this.contractNumberList = [];

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
      this.cdRef.detectChanges();
    });
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
    // let element: HTMLElement = document.getElementById('auto_triggerpayoff') as HTMLElement;
    // element.click();
    //this.getAlerts();

    if (this.payoffAccount != null && this.payoffAccount) {
      this.isFromAccount = false;
      this.onAccountRedirect(1);
    }
    else {
      this.isFromAccount = true;
    }
   this.selectedValue= " ";
  }

  DtpayToggle() {
    this.dtfhomepageService.PayToggle().subscribe((res) => {
      for (var i = 0; i < res.length; i++) {
        if (res[i].bannerType === "Pay" && res[i].bannerEnable === "Y"  && res[i].bannerExtra === null) {
          this.DTPAY = false;
        }
      }
      this.cdRef.detectChanges();
    });
  }


  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');

    this.formatAccountURl(redirect);
  }

  checkUrlParam(redirect: string, account: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('amortAccount', account);
    sessionStorage.setItem('classicredirect', 'yes');

    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL = this.accountRedirect + '?blink=' + redirect;
      if (this.langFlag === 'fr-CA') {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/fr/home/insurance';
        }
        else if (redirect === 'profile') {
          this.azURL = this.caUrl + '/cnet/fr/login/prepareEditProfile.do';
        }
        else if (redirect === 'pay') {
          this.azURL = this.caUrl + '/cnet/fr/customer/paymentOption.do';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/fr/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/fr/home/documentcenter';
        }
      }
      else {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'profile') {
          this.azURL = this.caUrl + '/cnet/en/login/prepareEditProfile.do';
        }
        else if (redirect === 'pay') {
          this.azURL = this.caUrl + '/cnet/en/customer/paymentOption.do';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/en/home/documentcenter';
        }
      }
    }
    else { //US Logic
      this.azURL = this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'autopay') {
        this.azURL = this.usUrl + '/inet/en/autoPay/autoPay.do';
      }
      else if (redirect === 'profile') {
        this.azURL = this.usUrl + '/inet/en/login/prepareEditProfile.do';
      }
      else if (redirect === 'insurance') {
        this.azURL = this.usUrl + '/home/insurance';
      }
      else if (redirect === 'amortization') {
        this.azURL = this.usUrl + '/home/amortization';
      }
      else if (redirect === 'documentcenter') {
        this.azURL = this.usUrl + '/home/documentcenter';
      }
      else if (redirect === 'invoice') {
        this.azURL = this.usUrl + '/home/invoice';
      }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);  //1s
  }

  formValidationClasses = {
    'mbfs-error': true,
  };
  // buildForm() {
  //   this.manageProfileForm = this.fb.group({
  //     currentPassword: [''],
  //     password: [''],
  //     reTypePassword: ['']
  //   });
  //   this.manageEmailForm = this.fb.group({
  //     emailAddress: [''],
  //     reEnterEmailAddress: [''],

  //   });
  // }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
      this.name = res.name;
      this.address = res.address1;
      this.address2 = res.address2;
      this.city = res.city;
      this.state = res.state;
      this.zipCode = res.zip;
      this.payoffAddress = this.address;
      if (this.address2) //null check for address 2
      {
        this.payoffAddress = this.payoffAddress + " " + this.address2;
      }
      this.payoffAddress2 = this.city + " " + this.state + " " + this.zipCode;
      this.prefill = true;
      this.cdRef.detectChanges();
    });
  }
  //Password Validation

  onClickPayoff(e: Event): void {
    // this.buildForm();
    this.openLoginModal = true;
  }

  togglePrefill(e: Event): void {
    this.prefill = !this.prefill;
    if (this.prefill) {
      const dashBoardRequest = {
        ciamId: this.ciamId,
        ciamAZCode: this.token
      };
      this.getDashBoardDetails(dashBoardRequest);
    }
    else {
      this.name = "";
      this.address = "";
      this.address2 = "";
      this.city = "";
      this.state = "";
      this.zipCode = "";
      this.payoffAddress = "";
      this.payoffAddress2 = "";
    }
  }

  vertexCall() {
    this.tableLoaded = false;
    this.addressRequestList = [];
    this.addressRequest = new AddressRequest();
    this.addressRequest.name = this.name;
    this.addressRequest.address = this.address;
    this.addressRequest.address2 = this.address2;
    this.addressRequest.city = this.city;
    this.addressRequest.state = this.state;
    this.addressRequest.zipCode = this.zipCode;
    this.addressRequestList.push(this.addressRequest);
    this.auth.SetAddressData(this.addressRequestList);
    // if(!this.frombackbuttom){
      this.openDialog(7);
    // }
  }

  titleAuthForm() {
  
    if (this.SelectContract) {
      if (this.OpenTitleAuth) {
        this.terminationDate = this.formatString(this.selectedDate.toString());
      }
      this.OpenTitleAuth = true;
        if (this.terminationDate != null) {
        this.createPayoffQuote();
      }
      else {
        this.tableLoaded = true;
      }
    }
    else if (this.SelectAsset) {
      if (this.OpenTitleAuth) {
        this.terminationDate = this.formatString(this.selectedDate.toString());
      }
      this.OpenTitleAuth = true;
        if (this.terminationDate != null) {
        this.createAssetPayoffQuote();
      }
      else {
        this.tableLoaded = true;
      }
    }
    else{
      if (this.OpenTitleAuth) {
        this.terminationDate = this.formatString(this.selectedDate.toString());
      }
      this.OpenTitleAuth = true;
    
    if (this.terminationDate != null) {
      this.createPayoffQuotebyVIN();
    }
    else {
      this.tableLoaded = true;
    }
    }
  }


  createPayoffQuotebyVIN() {
    this.tableLoaded = false;
    this.assetTotal = 1;
    this.payoffTotal = 0;
    const request = {
      "thirdPartyID": this.thirdPartyNumber,
      "userId": this.ciamId,
      "vin": this.inputValue,
      "brandId":this.brandId
    };
  
    // Call to API
    this.auth.getTerminationQuoteByVin(request).subscribe(
      (res2) => {
        // Handle success response
        if (res2.statusMessage === 'SUCCESS') {
          this.titleAuthNumberList = [];
          this.quotationNo = res2.quotationNo;
  
          // Append "001" to contract number
          res2.contractNumber = res2.contractNumber + "001";
          res2.terminatedAssetsCount = 1;
          this.displaycontractNumberList = res2.contractNumber;
  
          this.assetTotal = 1;
          this.payoffTotal = res2.quoteAmount;
          this.displayVinList = res2.vinNum;
  
          let contract = new ContractNumberRequest();
          contract.contractNumber = res2.contractNumber;
          contract.scheduleNumber = 1;
          contract.quoteNo = parseInt(res2.quoteNumber);
          this.titleAuthNumberList.push(contract);
  
          // Wrap the response in an array to pass to MatTableDataSource
          this.payoffResponseBeanList = [res2]; // Now it's an array of PayoffResponseBeanList

          this.vinListForPdfTable = '';
          this.vinListForPdfTable = this.inputValue;

          // Set up the MatTableDataSource with the array of PayoffResponseBeanList
          this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
          this.multipayoffdataSource.paginator = this.paginator;
          this.multipayoffdataSource.sort = this.sort;
  
          // Custom filterPredicate to handle contractNumber and vinNum filtering
          this.multipayoffdataSource.filterPredicate = (data, filter: string) => {
            const lowercasedFilter = filter.toLowerCase();
            return (data.contractNumber && data.contractNumber.toLowerCase().includes(lowercasedFilter)) ||
                   (data.vinNum && data.vinNum.toLowerCase().includes(lowercasedFilter));
          };
            setTimeout(() => {
            this.dbLoaded = true;
            this.filter = true;
            this.rowCount = this.multipayoffdataSource.filteredData.length;
            this.cdRef.detectChanges();
          });
  
       
  
          // Update UI states for success
          this.enableVinPayoff = true;
          this.SelectAsset = true;
          this.enableAssetPayoffQuote = true;
          this.disableDashboard = true;
          this.OpenTitleAuth = false;
          this.tableLoaded = true;

          if (!this.isInquiry) {
            this.SubmitTitleAuth();
          }
        }

        if (this.isCanadaPortal) {
          this.selectedAccountList = [];
          this.selectedAccount = new AccountNumber();
          this.selectedAccount.contractNumber = res2.contractNumber.slice(0, -3);
          this.selectedAccount.contractType = "FINANCE_LEASE";
          this.selectedAccount.scheduleNumber = "1";
          this.selectedAccountList.push(this.selectedAccount);
          this.tableLoaded = false;
         
          const request = { "accountList": this.selectedAccountList }
          this.vinDetailsRes = [];
          this.auth.getVinDetails(request).subscribe(res => {
            if (res) {
              res.forEach(element => {
                this.vinDetailsRes.push(element);
              });
            }
            this.cdRef.detectChanges();
          });
        }
        this.tableLoaded = true;
        this.cdRef.detectChanges();
      },
      (error) => {
        // Handle error response (e.g., 404 Not Found)
        if (error.status === 404) {
          console.log('404 Not Found Error: The requested resource was not found.');
        } else {
          console.log('Error occurred: ', error);
        }
  
        // Update UI flags for error state
        this.tableLoaded = true;
        this.isVin = true;
        this.required = true;
        this.OpenTitleAuth = false;
        this.SelectAsset = false;
        this.enableAssetPayoffQuote = false;
  
        // Trigger change detection if needed (optional depending on UI behavior)
        this.cdRef.detectChanges();
      }
    );
   
  }
  

  openPayoffQuote() {
    this.tableLoaded = false;
    this.checkToggleSelected(); //checks select Box
    if (this.contractSelected) {
      this.OpenTitleAuth = true;
      this.tableLoaded = true;
    }
    this.selectedDate = null;
  }

  createPayoffQuote() {
    this.tableLoaded = false;
    this.getAgreementAssetDetailRequest = {};
    this.getAgreementAssetDetailRequest = {
      accountList: this.contractNumberList,
      userId: this.ciamId,
    };

    this.auth.getMultiAgreementAssetDetail(this.getAgreementAssetDetailRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.getMultiPayoffRequest = {};
        this.getMultiPayoffRequest = {
          userId: this.ciamId,
          thirdPartyID: this.thirdPartyNumber,
          payOffType: "Contract",
          billingAddressNumber: 1,
          requester: 'A4444',
          terminationDate: this.terminationDate,
          brandId: this.brandId,
          accountList: res.accountList,
        };
        this.auth.getMultiPayoff(this.getMultiPayoffRequest).subscribe(res2 => {
          this.titleAuthNumberList = [];
          if (res2.statusMessage === 'SUCCESS') {
            this.quotationNo = res2.quotationNo;
            this.payoffResponseBeanList = res2.payoffResponseBeanList;
            this.assetTotal = 0;
            this.payoffTotal = 0;
            if (this.payoffResponseBeanList.length > 1) {
              this.displayPayNow = true;
            }
            if (Number(this.payoffResponseBeanList[0].quoteAmount) < 0) {
              this.isPositive = true;
            }
            var contractList = [];
            for (var i = 0; i < this.payoffResponseBeanList.length; i++) {
              this.payoffResponseBeanList[i].contractNumber = this.payoffResponseBeanList[i].contractNumber + '001';
              this.payoffResponseBeanList[i].onlinePayFlag = this.payoffResponseBeanList[i].onlinePayFlag;
              contractList.push(this.payoffResponseBeanList[i].contractNumber);
              this.vinListForPdfTable = '';
              let contract = new ContractNumberRequest();
              contract.contractNumber = this.payoffResponseBeanList[i].contractNumber;
              contract.scheduleNumber = this.payoffResponseBeanList[i].scheduleNumber;
              contract.quoteNo = +this.payoffResponseBeanList[i].quoteNumber;
              this.titleAuthNumberList.push(contract);
              this.displayVinList += (this.payoffResponseBeanList[i].terminatedAssetsList.toString());
              this.vinListForPdfTable += (this.payoffResponseBeanList[i].terminatedAssetsList.toString());
              this.assetTotal += Number(this.payoffResponseBeanList[i].terminatedAssetsCount);
              this.payoffTotal += Number(this.payoffResponseBeanList[i].quoteAmount);
              this.vinListForPdfTable = this.vinListForPdfTable.replace(/\,/g, '\n');
              this.quoteCreatedOn = this.payoffResponseBeanList[i].quoteCreatedTimestamp;
              this.payoffResponseBeanList[i].vinNum = this.vinListForPdfTable;
            }
            this.displaycontractNumberList = contractList.join(', ');
            this.assetTotal = Math.round(this.assetTotal * 100) / 100;
            this.payoffTotal = Math.round(this.payoffTotal * 100) / 100;
            this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
            this.multipayoffdataSource.paginator = this.paginator;
            this.multipayoffdataSource.sort = this.sort;
            this.multipayoffdataSource.filterPredicate = function (data, filter: string): boolean {
              return data.contractNumber.toLowerCase().includes(filter) || data.vinNum.toLowerCase().includes(filter);
            };
            setTimeout(() => {
              this.dbLoaded = true;
              this.filter = true;
              this.rowCount = this.multipayoffdataSource.filteredData.length;
            });
            this.cdRef.detectChanges();
            this.enablePayoffQuote = true;
            this.disableDashboard = true;
            if (!this.isInquiry) {
              this.SubmitTitleAuth();
            }

          this.cdRef.detectChanges();
          }
          this.tableLoaded = true;
          this.OpenTitleAuth = false;
          this.cdRef.detectChanges();
        });

        if (this.isCanadaPortal) {
          const request = { "accountList": res.accountList };
          this.vinDetailsRes = [];
          this.auth.getVinDetails(request).subscribe(res => {
            if (res) {
              res.forEach(element => {
                this.vinDetailsRes.push(element);
                this.cdRef.detectChanges();
              });
            }
            this.cdRef.detectChanges();
          });
        }
      }
      else {
      }
    });
  }

  listLiveAndExpiredQuotes(accountDetailsRequest) {
    this.tableLoaded = false;
    this.cdRef.detectChanges();
    this.auth.listliveAndExpiredQuotes(accountDetailsRequest).subscribe(res3 => {

      this.ViewPayOffListLive = [];
      this.ViewPayOffListLive = (res3.viewPayOffListLive || []).filter(item => item.status === 'LIVE');
      for (let i = 0; i < this.ViewPayOffListLive.length; i++) {
        const item = this.ViewPayOffListLive[i];

        // Append '001' to agreement number
        item.agreementNumber += '001';

        const dt = item.dateTime;
        if (typeof dt === 'number') {
          // Convert timestamp to yyyy-MM-dd string
          const formattedDate = new Date(dt).toISOString().split('T')[0];
          item.dateTime = formattedDate;
        } else if (typeof dt === 'string' && dt.includes('T')) {
          item.dateTime = dt.split('T')[0];
        } else {
          console.warn('Unexpected or missing dateTime:', dt);
        }
      }
      this.cdRef.detectChanges();
      this.tableLoaded = true;
      this.listLiveAndExpiredQuotesdataSource = new MatTableDataSource(this.ViewPayOffListLive);
      this.listLiveAndExpiredQuotesdataSource.paginator = this.paginator;
      this.listLiveAndExpiredQuotesdataSource.sort = this.sort;
      //this.sort.sort({ id: 'status', start: 'desc', disableClear: true });
      setTimeout(() => {
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.listLiveAndExpiredQuotesdataSource.filteredData.length;
        this.cdRef.detectChanges();
      });
    });

  }
   
  onContinueClick(value: string) {
  this.selectedValue = value;
  this.onSelectPayoff();
  }
    
  onSelectPayoff(){
    this.getAccountDetailsListByUserId();
    if (this.selectedValue == "byAccount") {
      this.SelectContract = true;
      this.isInquiry = false;
      this.viewpayoff = false;
      this.MoreAccountsFlow = false;
      this.isVin = false;
    }
    else if(this.selectedValue == "byAsset") {
      this.SelectContract = false;
      this.SelectAsset = true;
      this.isInquiry = false;
      this.viewpayoff = false;
      this.MoreAccountsFlow = false;
      this.isVin = false;
    }
    else if(this.selectedValue == "byVin") {
      this.isVin = true;
      this.required = false;
      this.SelectContract = false;
      this.SelectAsset = false;
      this.isInquiry = false;
      this.viewpayoff = false;
      this.MoreAccountsFlow = false;
    }
    else if(this.selectedValue == "ForAccount") {
      this.SelectContract = true;
      this.isInquiry = true;
      this.viewpayoff = false;
      this.MoreAccountsFlow = false;
      this.isVin = false;
    }
    else if(this.selectedValue == "ForAsset") {
      this.SelectAsset = true;
      this.SelectContract = false;
      this.isInquiry = true;
      this.viewpayoff = false;
      this.MoreAccountsFlow = false;
      this.isVin = false;
    }
  }

 
  // viewPayoff() {
  //   const request = {
  //     userId: "NewUserId",
  //     country: this.currentCountry

  //   };
  //   this.auth.viewPayoff(request).subscribe(res3 => {
  //     this.titleAuthNumberAccountList = [];
  //     if (res3.statusMessage === 'SUCCESS') {
  //       this.viewPayoffList = res3.viewPayOffList;
  //       this.assetTotal = 0;
  //       if (this.viewPayoffList.length > 1) {
  //         this.displayPayNow = true;
  //       }
  //       if (Number(this.viewPayoffList[0].quoteAmt) < 0) {
  //         this.isPositive = true;
  //       }
  //       for (var i = 0; i < this.viewPayoffList.length; i++) {
  //         this.viewPayoffList[i].accountNbr = this.viewPayoffList[i].accountNbr + '001';
  //         this.displayaccountNumberList += (this.viewPayoffList[i].accountNbr + ', ');
  //         this.displaycontractNumberList = this.displaycontractNumberList.slice(0, this.displaycontractNumberList.lastIndexOf("_"));
  //         let account = new AccountNumberRequest();
  //         account.accountNbr = this.viewPayoffList[i].accountNbr;
  //         account.scheduleNbr = this.viewPayoffList[i].scheduleNbr;
  //         account.quoteNumber = +this.viewPayoffList[i].quoteNumber;
  //         this.titleAuthNumberAccountList.push(account);
  //         this.assetTotal += Number(this.viewPayoffList[i].assetCount);

  //       }
  //       this.assetTotal = Math.round(this.assetTotal * 100) / 100;

  //       this.viewpayoffdataSource = new MatTableDataSource(this.viewPayoffList);
  //       this.viewpayoffdataSource.paginator = this.paginator;
  //       this.viewpayoffdataSource.sort = this.sort;
  //       this.viewpayoffdataSource.filterPredicate = function (data, filter: string): boolean {
  //         return data.accountNbr.toLowerCase().includes(filter);
  //       };
  //       setTimeout(() => {
  //         this.dbLoaded = true;
  //         this.filter = true;
  //         this.rowCount = this.viewpayoffdataSource.filteredData.length;
  //       });

  //     } else {
  //       alert('failed');
  //       //console.log('viewpayoff is not working');
  //     }

  //   });
  // }

  vindetails(accountNum: string) {

    this.selectedAccountList = [];
    this.selectedAccount = new AccountNumber();
    this.selectedAccount.contractNumber = accountNum.slice(0, -3);
    this.selectedAccount.contractType = "FINANCE_LEASE";
    this.selectedAccount.scheduleNumber = "1";
    this.selectedAccountList.push(this.selectedAccount);
    this.tableLoaded = false;
    const request = { "accountList": this.selectedAccountList }

    
    this.auth.getVinDetails(request).subscribe(res => {
      this.vinDetailsRes = [];
      if (res) {
        res.forEach(element => {
          this.vinDetailsRes.push(element);
        });
        this.cdRef.detectChanges();
        this.vinDataSource1 = new MatTableDataSource(this.vinDetailsRes);
        this.tableLoaded = true;
      }     
      this.cdRef.detectChanges();
    });
  }

  openVinPayoff() {

    this.tableLoaded = false;
    if (!this.payoffAccount) {
      this.checkSingleToggleSelected(); //checks select Box
    }
    if (this.contractSelected) {
      this.getAgreementAssetDetailRequest = {};
      this.getAgreementAssetDetailRequest = {
        accountList: this.contractNumberList,
        userId: this.ciamId,
      };
      this.auth.getMultiAgreementAssetDetail(this.getAgreementAssetDetailRequest).subscribe(res => {
        if (res.statusMessage === 'SUCCESS') {
          this.assetListRes = [];
          this.vinResponse = res.accountList;
          this.vinType = res.accountList[0].contractType;
          for (var i = 0; i < this.vinResponse.length; i++) {
            for (var j = 0; j < this.vinResponse[i].assetList.length; j++) {
              this.tempAssetListResponse = new AssetListResponse();
              this.tempAssetListResponse.agreementNum = this.vinResponse[i].contractNumber;
              this.tempAssetListResponse.assetID = this.vinResponse[i].assetList[j].assetID;
              this.tempAssetListResponse.vinNum = this.vinResponse[i].assetList[j].vinNum;
              this.tempAssetListResponse.onlinePayFlag = this.vinResponse[i].onlinePayFlag;
              this.assetListRes.push(this.tempAssetListResponse);
            }
          }
          this.vinDataSource = new MatTableDataSource(this.assetListRes);
          this.cdRef.detectChanges();
          setTimeout(() => {
            this.vinDataSource.paginator = this.paginator;
            this.vinDataSource.sort = this.sort;
            this.vinDataSource.filterPredicate = function (data, filter: string): boolean {
              return data.agreementNum.toLowerCase().includes(filter) || data.vinNum.toLowerCase().includes(filter);
            };
            this.dbLoaded = true;
            this.filter = true;
            this.rowCount = this.vinDataSource.filteredData.length;
            this.cdRef.detectChanges();
          });

          this.enableVinPayoff = true;
          if (this.payoffAccount) {
            this.cdRef.detectChanges();
            this.SelectAsset = true;
            this.isFromAccount = true;
          }
          this.disableDashboard = true;
        }
        this.cdRef.detectChanges();
        this.tableLoaded = true;
        this.cdRef.detectChanges();
      });
    }
  }

  createAssetPayoffQuote() {
    this.tableLoaded = false;
    this.vinResponseList = [];
    for (var i = 0; i < this.assetListRequest.length; i++) {
      var boolean = false;
      this.tempVinResponse = new VinResponse();
      this.tempAssetListResponse = new AssetListResponse();
      this.tempVinResponse.contractNumber = this.assetListRequest[i].agreementNum;
       this.tempVinResponse.onlinePayFlag = this.assetListRequest[i].onlinePayFlag;
      this.tempVinResponse.contractType = this.vinType;
      this.tempVinResponse.scheduleNumber = "1";
      this.tempAssetListResponse.assetID = this.assetListRequest[i].assetID;
      this.tempAssetListResponse.vinNum = this.assetListRequest[i].vinNum;
      this.tempVinResponse.assetList.push(this.tempAssetListResponse);
      for (var j = 0; j < this.vinResponseList.length; j++) {
        if (this.vinResponseList[j].contractNumber === this.tempVinResponse.contractNumber) {
          this.vinResponseList[j].assetList.push(this.tempAssetListResponse);
          boolean = true;
        }
      }
      if (!boolean) {
        this.vinResponseList.push(this.tempVinResponse);
      }
    }
    this.getMultiPayoffRequest = {};
    this.getMultiPayoffRequest = {
      userId: this.ciamId,
      thirdPartyID: this.thirdPartyNumber,
      billingAddressNumber: 1,
      requester: 'A4444',
      payOffType: "Vin",
      terminationDate: this.terminationDate,
      brandId: this.brandId,
      accountList: this.vinResponseList,
    };
    this.auth.getMultiPayoff(this.getMultiPayoffRequest).subscribe(res2 => {
      this.titleAuthNumberList = [];
      if (res2.statusMessage === 'SUCCESS') {
        this.quotationNo = res2.quotationNo;
        this.payoffResponseBeanList = res2.payoffResponseBeanList;
        this.assetTotal = 0;
        this.payoffTotal = 0;
        if (this.payoffResponseBeanList.length > 1) {
          this.displayPayNow = true;
        }
        if (Number(this.payoffResponseBeanList[0].quoteAmount) < 0) {
          this.isPositive = true;
        }
        var contractList = [];
        for (var i = 0; i < this.payoffResponseBeanList.length; i++) {
          this.payoffResponseBeanList[i].contractNumber = this.payoffResponseBeanList[i].contractNumber + '001';
          let contract = new ContractNumberRequest();
          contract.contractNumber = this.payoffResponseBeanList[i].contractNumber;
          contract.scheduleNumber = this.payoffResponseBeanList[i].scheduleNumber;
          contract.quoteNo = +this.payoffResponseBeanList[i].quoteNumber;
          this.titleAuthNumberList.push(contract);
          contractList.push(this.payoffResponseBeanList[i].contractNumber);
          this.displayVinList += (this.payoffResponseBeanList[i].terminatedAssetsList.toString());
          this.vinListForPdfTable += (this.payoffResponseBeanList[i].terminatedAssetsList.toString());
          this.assetTotal += Number(this.payoffResponseBeanList[i].terminatedAssetsCount);
          this.payoffTotal += Number(this.payoffResponseBeanList[i].quoteAmount);
          this.vinListForPdfTable = this.vinListForPdfTable.replace(/\,/g, '\n');
          this.payoffResponseBeanList[i].vinNum = this.vinListForPdfTable;
          this.quoteCreatedOn = this.payoffResponseBeanList[i].quoteCreatedTimestamp;
        }
        this.displaycontractNumberList = contractList.join(', ');
        this.assetTotal = Math.round(this.assetTotal * 100) / 100;
        this.payoffTotal = Math.round(this.payoffTotal * 100) / 100;
        this.multipayoffdataSource = new MatTableDataSource(this.payoffResponseBeanList);
        this.multipayoffdataSource.paginator = this.paginator;
        this.multipayoffdataSource.sort = this.sort;
        this.multipayoffdataSource.filterPredicate = function (data, filter: string): boolean {
          return data.contractNumber.toLowerCase().includes(filter) || data.vinNum.toLowerCase().includes(filter);
        };
        setTimeout(() => {
          this.cdRef.detectChanges();
          this.dbLoaded = true;
          this.filter = true;
          this.rowCount = this.multipayoffdataSource.filteredData.length;
          this.cdRef.detectChanges();
        });


        this.enableAssetPayoffQuote = true;
        this.disableDashboard = true;
        this.OpenTitleAuth = false;
        if (!this.isInquiry) {
          this.SubmitTitleAuth();
        }
      }
      this.tableLoaded = true;
      this.cdRef.detectChanges();
    });
    if (this.isCanadaPortal) {
      const request = { "accountList": this.vinResponseList };
      this.vinDetailsRes = [];
      this.auth.getVinDetails(request).subscribe(res => {
        if (res) {
          res.forEach(element => {
            this.vinDetailsRes.push(element);
            this.cdRef.detectChanges();
          });
        }
        this.cdRef.detectChanges();
      });
    }
  }
  openAssetPayoffQuote() {
    this.tableLoaded = false;
    this.checkVinToggleSelected(); //checks select Box
    if (this.vinSelected) {
      this.OpenTitleAuth = true;
      this.tableLoaded = true;
    }
    this.selectedDate = null;
    this.cdRef.detectChanges();
  }

  ByVin(){

    const vinRegex = /^[A-Za-z0-9]{17}$/;

    // Check if input is 17 characters long and matches the regex
    if (this.inputValue.length === 17 && vinRegex.test(this.inputValue)) {
      this.isVin = false;
      this.error = false;
      this.required = false;
      this.ifVin = true;
      this.OpenTitleAuth = true;
      this.tableLoaded = true;
      this.selectedDate = null;
    } else {
     this.error = true;
    }

  
  }

  formatString(date: string): string {
    let newDate = new Date(date);
    let day: string = newDate.getDate().toString();
    day = +day < 10 ? '0' + day : day;
    let month: string = (newDate.getMonth() + 1).toString();
    month = +month < 10 ? '0' + month : month;
    let year = newDate.getFullYear();
    return `${year}-${month}-${day}`;
  }

  newDateFormat() {
    let newDate: Date = new Date();
    let day: string = newDate.toLocaleString();
    day = +day < 10 ? '0' + day : day;
    let month: string = (newDate.getMonth() + 1).toString();
    month = +month < 10 ? '0' + month : month;
    let year = newDate.getFullYear();
    return `${year}-${month}-${day}`;
  }
  // formatDate(): string {
  //   formatDate(new Date(), 'yyyy-MM-dd', 'en');

  //   let newDate: Date = new Date();
  //     let day: string = newDate.toLocaleString();
  //     day = +day < 10 ? '0' + day : day;
  //     let month: string = (newDate.getMonth() + 1).toString();
  //     month = +month < 10 ? '0' + month : month;
  //     let year = newDate.getFullYear();
  //     return `${year}-${month}-${day}`;
  // }

  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = [];
      this.accountDetailsRes = res.accountdetailsList;
      for (var i = this.accountDetailsRes.length - 1; i >= 0; i--) {
        if (this.accountDetailsRes[i].status !== 'LIVE') {
          this.accountDetailsRes.splice(i, 1);
        }
        else if (this.accountDetailsRes[i].terminationQuoteBlocked) {
          this.accountDetailsRes.splice(i, 1);
        }
        else if (this.accountDetailsRes[i].contractType !== 'LOAN') {
          if (!this.isCanadaPortal) {
            this.accountDetailsRes.splice(i, 1);
          }
        }
        else {
          this.loanAccounts = true;
        }
      }
      this.dataSource = new MatTableDataSource(this.accountDetailsRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function (data, filter: string): boolean {
        return data.contractNum.toLowerCase().includes(filter) || data.status.toLowerCase().includes(filter) || data.contractType.toLowerCase().includes(filter);
      };
      setTimeout(() => {
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
        this.cdRef.detectChanges();
      });
      if (this.payoffAccount != null && this.payoffAccount) {
        this.onAccountRedirect(2);
      }
      if(!this.SelectAsset && !this.SelectContract && !this.isVin && !this.isInquiry){
       this.useAccountDetailsResponse();
      }
      this.cdRef.detectChanges();
    });
  }

  useAccountDetailsResponse(){

    if(this.recAccCount && parseInt(this.recAccCount) < 450) {
    this.viewpayoff = true;
    this.MoreAccountsFlow = false;
    const accountDetailsRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      accountdetailsList:this.accountDetailsRes
    };
    this.listLiveAndExpiredQuotes(accountDetailsRequest);
    }else{
      this.viewpayoff = false;
      this.MoreAccountsFlow = true;
    }

  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.enablePayoffQuote = false;
    this.enableVinPayoff = false;
    this.enableAssetPayoffQuote = false;
    this.SelectContract = false;
    this.SelectAsset = false;
    this.disableDashboard = false;
    this.serviceErrorOccurred = false;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public disableCheckbox(): boolean {
    return this.selectionsingle.selected.length >= 1;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkToggleSelected() {
    this.contractNumberList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected < 1) {
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;
      this.tableLoaded = true;
    }
    else if (numSelected > 10) {
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please select at less than 10 account(s)');
      this.openDialog(5);
      this.contractSelected = false;
      this.tableLoaded = true;
    }
    else {
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
      this.contract = new ContractNumberRequest();
      this.contract.contractNumber = this.selection.selected[i].contractNum.slice(0, -3);
      this.contract.scheduleNumber = 1;
      this.contract.contractType = this.selection.selected[i].contractType;
      this.contract.onlinePayFlag=this.selection.selected[i].onlinePayFlag;
      this.contractNumberList.push(this.contract);
    }
  }

  checkSingleToggleSelected() {
    this.contractNumberList = [];
    const numSelected = this.selectionsingle.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected < 1) {
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;
      this.tableLoaded = true;
    }
    else {
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selectionsingle.selected.length; i++) {
      this.contract = new ContractNumberRequest();
      this.contract.contractNumber = this.selectionsingle.selected[i].contractNum.slice(0, -3);
      this.contract.scheduleNumber = 1;
      this.contract.contractType = this.selectionsingle.selected[i].contractType;
      this.contract.onlinePayFlag=this.selectionsingle.selected[i].onlinePayFlag;
      this.contractNumberList.push(this.contract);
    }
  }



  isAllVinSelected() {
    const numSelected = this.selection2.selected.length;
    const numRows = this.vinDataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterVinToggle() {
    this.isAllSelected() ?
      this.selection2.clear() :
      this.vinDataSource.data.forEach(row => this.selection2.select(row));
  }

  checkVinToggleSelected() {
    this.tableLoaded = false;
    this.contractNumberList = [];
    const numSelected = this.selection2.selected.length;
    const numRows = this.vinDataSource.data.length;
    if (numSelected < 1) {
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.vinSelected = false;
      this.tableLoaded = true;
    }
    else {
      this.vinSelected = true;
    }

    for (var i = 0; i < this.selection2.selected.length; i++) {
      let asset = new AssetListResponse();
      this.assetListRequest.push(this.selection2.selected[i]);
    }
  }

  onPayNowClick(contractNum: string, quoteAmount: string, quoteNumber: string) {
    this.tableLoaded = false;

    // this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('page', 'payoff_quote');
    sessionStorage.setItem('amount', quoteAmount);
    sessionStorage.setItem('selectedAcct', contractNum);
    sessionStorage.setItem('quoteNumber', quoteNumber);

    // if(this.DTPAY == true){
    this.azURL = this.usUrl + '/home/onlinepayment';
    // }else{
    // this.azURL = this.usUrl + '/home/pay';
    // }
    // this.azURL = this.usUrl + '/home/pay/page=payoff_quote&amount=' + quoteAmount + '&selectedAcct=' + contractNum;
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
      this.tableLoaded = false;
    }, 1000);  //1s
  }

  onPayNowClickViewPayOff(AccountNumber: string, QuoteAmount: string, QuoteNumber: string) {
    this.tableLoaded = false;

    // this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('page', 'payoff_quote');
    sessionStorage.setItem('amount', QuoteAmount);
    sessionStorage.setItem('selectedAcct', AccountNumber);
    sessionStorage.setItem('quoteNumber', QuoteNumber);

    // if(this.DTPAY == true){
    this.azURL = this.usUrl + '/home/onlinepayment';
    // }else{
    // this.azURL = this.usUrl + '/home/pay';
    // }

    // this.azURL = this.usUrl + '/home/pay/page=payoff_quote&amount=' + quoteAmount + '&selectedAcct=' + contractNum;
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
      this.tableLoaded = false;
    }, 1000);  //1s

  }

  exportTableviewpayoff(Account: string, quotenum: number, status: string, payoffAmt: number, GoodThrough: string, AssetCount: Number, requestdate: string) {

    this.tableLoaded = false;
    this.cdRef.detectChanges();
    const doc = new jsPDF({ format: 'a4' });
    let customerName = this.customerName;
    let name=this.name;
    // var m_names = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
    // var newdat1 = m_names[new Date(this.selectedDate.toString()).getMonth()] + ' ' + new Date(this.selectedDate.toString()).getDate() + ', ' + new Date(this.selectedDate.toString()).getFullYear();
    let date = GoodThrough;
    let amount = payoffAmt;
    let accountNum = Account;
    let requestdates = requestdate;
    let payoffAddress = this.address ? this.address : this.payoffAddress;
    let payoffAddress2 = this.address2;
    let payoffAddress3 = this.city + "," + this.state;
    let payoffAddress4 = this.zipCode
    var rows = [];
    var options = { style: 'currency', currency: 'USD' };
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    var Header = [
      ["Account", "Quote Number","Status", "Payoff Amount","Payoff Request", "Asset Count",  "Good Through"],
    ];
    const head = Header;
    const data = this.listLiveAndExpiredQuotesdataSource.data;
    
    data.forEach(element => {
     if(Account== element.agreementNumber && quotenum == element.quotationNumber && status == element.status && payoffAmt == element.amount && requestdate == element.dateTime 
      && AssetCount == element.numberOfAssets && GoodThrough == element.goodThrough){
      var temp = [Account, quotenum, status,formatter.format(payoffAmt) ,requestdate  ,AssetCount,  GoodThrough]
      rows.push(temp);
      }
    });
     this.service.exportPdfPayoffTxHistory(doc, customerName, accountNum, amount, head, rows, payoffAddress, payoffAddress2, payoffAddress3, payoffAddress4, date, requestdates);
    
    this.tableLoaded = true;
    this.cdRef.detectChanges();
  }

  exportTableviewpayoffCA(Account: string, quotenum: number, status: string, payoffAmt: number, GoodThrough: string, AssetCount: Number, requestdate: string) {

    this.tableLoaded = false;
    this.cdRef.detectChanges();
    const doc = new jsPDF({ format: 'a4' });
    let customerName = this.customerName;
    let name=this.name;
    // var m_names = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
    // var newdat1 = m_names[new Date(this.selectedDate.toString()).getMonth()] + ' ' + new Date(this.selectedDate.toString()).getDate() + ', ' + new Date(this.selectedDate.toString()).getFullYear();
    let date = GoodThrough;
    let requestdates = requestdate;
    let amount = payoffAmt;
    let accountNum = Account;
    let payoffAddress = this.address ? this.address : this.payoffAddress;
    let payoffAddress2 = this.address2;
    let payoffAddress3 = this.city + "," + this.state;
    let payoffAddress4 = this.zipCode
    var rows = [];
    var options = { style: 'currency', currency: 'USD' };
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const data1 = this.listLiveAndExpiredQuotesdataSource.data;
    
    data1.forEach(element => {
     if(Account== element.agreementNumber && quotenum == element.quotationNumber && status == element.status && payoffAmt == element.amount && requestdate == element.dateTime 
      && AssetCount == element.numberOfAssets && GoodThrough == element.goodThrough){
      var temp = [Account, quotenum, status,formatter.format(payoffAmt) , requestdate ,AssetCount, GoodThrough]
      rows.push(temp);
      }
    });


    if (this.isFrench) {
    var Header = [["Compte", "Numéro de devis", "Statut", "Montant du remboursement",  "Demande de remboursement", "Nombre d’actifs", "Valide jusqu’au"],];
    const head = Header;
    this.service.exportPdfPayoffTxHistoryFR(doc, customerName, accountNum, amount, head, rows, payoffAddress, payoffAddress2, payoffAddress3, payoffAddress4, date, requestdates);
    }else{
    var Header = [["Account", "Quote Number","Status", "Payoff Amount","Good Through", "Asset Count",  "Payoff Request"],];
    const head = Header;
    this.service.exportPdfPayoffTxHistoryCA(doc, customerName, accountNum, amount, head, rows, payoffAddress, payoffAddress2, payoffAddress3, payoffAddress4, date, requestdates);

    }
    
    this.tableLoaded = true;
    this.cdRef.detectChanges();
  }


  payoffRedirect(e: Event) {
    sessionStorage.setItem('skipterminate', 'yes');
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data: any) => {
      redirect = this.usUrl + data;
    });
    window.location.href = redirect;
  }

  openDialog(num: any): void {
    if (num === 1) {
      sessionStorage.setItem('payoffdialog', 'one');
    }
    if (num === 5) {
      sessionStorage.setItem('payoffdialog', 'error');
    }
    if (num === 6) {
      sessionStorage.setItem('payoffdialog', 'six');
    }
    if (num === 7) {
      sessionStorage.setItem('payoffdialog', 'seven');
    }
    if (num === 7) {
      let dialogRef = this.dialog.open(PayoffDialogComponent, {
        maxWidth: '200vw',
        width: '900px',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        this.tableLoaded = true;
        this.cdRef.detectChanges();
        let addressValid = sessionStorage.getItem('addressValid');
        if (addressValid === 'yes') {
          this.auth.cast5.subscribe((tempaddress: any) => {
            this.addressRequestList = tempaddress;
            this.address = this.addressRequestList[0].address;
            this.address2 = this.addressRequestList[0].address2;
            this.city = this.addressRequestList[0].city;
            this.state = this.addressRequestList[0].state;
            this.zipCode = this.addressRequestList[0].zipCode;
            this.tableLoaded = false;
            this.titleAuthForm();
            this.cdRef.detectChanges();
            // setTimeout(() => {
            //   this.tableLoaded = true;
            // }, 6000);  //2s        
          });
        }
      });
    }
    else {
      let dialogRef = this.dialog.open(PayoffDialogComponent, {
        maxWidth: '200vw',
        width: '500px',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }



  }

  //export payoff

  exportTableUS() {
    this.tableLoaded = false;
    this.cdRef.detectChanges();
    const doc = new jsPDF({ format: 'a4' });
    let customerName = this.customerName;
    let name=this.name;
    var m_names = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
    var newdat1 = m_names[new Date(this.selectedDate.toString()).getMonth()] + ' ' + new Date(this.selectedDate.toString()).getDate() + ', ' + new Date(this.selectedDate.toString()).getFullYear();
   
    
   // Split parts
const [datePart, timePart] = this.quoteCreatedOn.split(" ");
let [month, day, year] = datePart.split("/").map(Number);
let [hour, minute] = timePart.split(":").map(Number);

// Month names
const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
   // Convert 24h → 12h
const ampm = hour >= 12 ? "pm" : "am";
hour = hour % 12 || 12;
// Final formatted string
const formattedDate =
  `${months[month - 1]} ${day}, ${year} at ${hour}:${minute.toString().padStart(2, "0")}${ampm}`;

    let quoteCreated=formattedDate;
    let payoffTotal = this.payoffTotal;
    let displaycontractNumberList = this.displaycontractNumberList;
    let payoffAddress = this.address ? this.address : this.payoffAddress;
    let payoffAddress2 = this.address2;
    let payoffAddress3 = this.city + "," + this.state;
    let payoffAddress4 = this.zipCode
    var rows = [];
    var options = { style: 'currency', currency: 'USD' };
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    var Header = [
      ["Account", "Quote Number", "Quote Amount", "Asset Count", "VIN"],
    ];
    const head = Header;
    const data = this.multipayoffdataSource.data;
    var options = { style: 'currency', currency: 'USD' };
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    data.forEach(element => {
      var temp = [element.contractNumber, element.quoteNumber, formatter.format(parseFloat(element.quoteAmount)),
      element.terminatedAssetsCount, element.vinNum]
      rows.push(temp);
    });
    this.service.exportPdfUS(doc, newdat1, quoteCreated,name, customerName, payoffAddress, payoffAddress2, payoffAddress3, payoffAddress4, displaycontractNumberList, payoffTotal, head, rows);
    this.tableLoaded = true;
    this.cdRef.detectChanges();
  }

  exportTableCA() {
    this.tableLoaded = false;
    this.cdRef.detectChanges();

    const doc = new jsPDF({ format: 'a4' });
    let customerName = this.customerName;
    let longValue = '';
    let translate = this.translate;
    let selectedDate = this.formatString(this.selectedDate.toString());
    let payoffTotal = this.payoffTotal;
    let displaycontractNumberList = this.displaycontractNumberList;
    let payoffAddress = this.payoffAddress;
    let payoffAddress2 = this.payoffAddress2;
    var rows = [];
    var options = { style: 'currency', currency: 'USD' };
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    var data;
    if (this.SelectContract) {
      data = this.vinDetailsRes;
    } else if (this.SelectAsset) {
      data = this.vinDetailsRes = this.vinDetailsRes.filter(x => this.vinListForPdfTable.includes(x.vinNum));
    } else {
      data = this.vinDetailsRes;
    }
    data.forEach(element => {
      var temp = [element.year, element.manufacturer, element.model, element.vinNum];
      rows.push(temp);
    });
    // rows.push([{ content: 'TOTAL : ', colSpan: 4, styles: { halign: 'left' } },
    // { content: formatter.format(Number(this.payoffTotal)), styles: { halign: 'left' } }]
    // );

    if (this.isFrench) {
      var Header = [["Année", "Marque", "Modèle", "NIV"],];
      const head = Header;
      this.service.exportPdfFR(doc, selectedDate, customerName, payoffAddress, payoffAddress2, displaycontractNumberList, payoffTotal, head, rows);
    } else {
      var Header = [["Year", "Make", "Model", "VIN"],];
      const head = Header;
      this.service.exportPdfEN(doc, selectedDate, customerName, payoffAddress, payoffAddress2, displaycontractNumberList, payoffTotal, head, rows);
    }
    this.tableLoaded = true;
    this.cdRef.detectChanges();
  }

//back button code 

//backstep from account to payoff page
  backstep1() {
    window.location.reload();
    this.bodyLoaded = false;
    // this.SelectContract = false;
    // this.SelectAsset = false;
    this.isVin = false;
    // this.isFromAccount = true;
    if(this.recAccCount && parseInt(this.recAccCount) < 400){
      this.viewpayoff = true;
      this.MoreAccountsFlow = false;
    }else{
      this.viewpayoff = false;
      this.MoreAccountsFlow = true;
    }
    this.SelectAsset = false;
    this.isInquiry = false;
    this.SelectContract = false;
    this.selectedState = 5;


  }

  //backstep from addresspage to account page
  backstep2Account() {



    this.SelectContract = true;
    this.enablePayoffQuote = false;
    this.OpenTitleAuth = false;

    setTimeout(() => {
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
      this.dataSource.paginator = this.paginator;
      this.cdRef.detectChanges();
    });

  }

  //backstep from address page to vin account page (payoffbyassets)
  backstep2VinAsset() {

    this.SelectAsset = true;
    this.enableVinPayoff = true;
    this.enableAssetPayoffQuote = false;
    this.OpenTitleAuth = false;

    setTimeout(() => {
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.vinDataSource.filteredData.length;
      this.vinDataSource.paginator = this.paginator;
      this.cdRef.detectChanges();
    });

    if(this.ifVin == true){
      this.isVin = true;
      this.required = false;
      this.OpenTitleAuth = false;
      this.SelectAsset = false;
      this.enableAssetPayoffQuote = false;
    }

  }

// backstep from final download page to address page
  backstep2Addresspage() {
    this.OpenTitleAuth = true;
    // this.prefill=true;
    // this.frombackbuttom=true;
  }

  //backstep from vin page to accounts page (payoffbyassets)
  backstep2Asset() {
    this.SelectAsset = true;
    this.enableVinPayoff = false;

    setTimeout(() => {
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
      this.dataSource.paginator = this.paginator;
      this.cdRef.detectChanges();
    });
  }

}


@Component({
    selector: 'dialog-payoffPopup',
    imports: [
        MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule, MatSortModule,
        MatDialogContent, MatDialogActions,
        MatDialogClose,
    ],
    templateUrl: 'payoffPopupDialog.component.html'
})
export class PayoffDialogComponent {
  usUrl: string;
  caUrl: string;
  payoffdialog: string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];
  addressRequest: AddressRequest;
  addressRequestList: AddressRequest[];
  vertexPostalAddress: VertexPostalAddress;
  vertexAddressResponse: VertexAddressResponse[];
  dbLoaded = false;
  filterActive = false;
  hideError = false;
  filter = false;
  statusMessage = "";
  rowCount = 0;
  value = '';

  tableLoaded = true;

  VertexAddressArrayResponse

  initColumns: any[] = [
    {
      name: 'streetAddress1',
      display: 'Address',
      displayFR: 'Address',
      dispFormat: 'Address'
    },
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
  ];
  dataSource: MatTableDataSource<VertexAddressResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  displayedColumns: any[] = this.initColumns.map(col => col.name);

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog,
    public dialogRef: MatDialogRef<PayoffDialogComponent>, private cdRef: ChangeDetectorRef

  ) {
    this.contractNumberList = [];
    this.vertexAddressResponse = [];
    this.dataSource = new MatTableDataSource(this.vertexAddressResponse);
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.payoffdialog = sessionStorage.getItem('payoffdialog');

    if (this.payoffdialog === 'seven') {
      this.auth.cast5.subscribe((address: any) => {
        this.tableLoaded = false;
        this.addressRequestList = [];
        this.addressRequestList = address;
        this.vertexPostalAddress = new VertexPostalAddress;
        this.vertexPostalAddress.addressLine1 = this.addressRequestList[0].address;
        this.vertexPostalAddress.addressLine2 = this.addressRequestList[0].address2;
        this.vertexPostalAddress.city = this.addressRequestList[0].city;
        this.vertexPostalAddress.state = this.addressRequestList[0].state;
        this.vertexPostalAddress.county = "";
        this.vertexPostalAddress.postalCode = this.addressRequestList[0].zipCode;
        this.vertexPostalAddress.country = "US";
        this.vertexPostalAddress.userId = "A4444";
        //Vertex Service Call
        this.vertexAddressResponse = [];
        this.auth.validateAddress(this.vertexPostalAddress).subscribe(res => {
          this.tableLoaded = true;
          this.statusMessage = res.statusCode;
          this.vertexAddressResponse = res.address;
          if (res.address.length > 0) {
            this.hideError = true;
          }
          this.dataSource = new MatTableDataSource(this.vertexAddressResponse);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.cdRef.detectChanges();
          setTimeout(() => {
            this.dbLoaded = true;
            this.filter = true;
            this.rowCount = this.dataSource.filteredData.length;
            this.cdRef.detectChanges();
          });
        }, () => {
          this.tableLoaded = true;
          this.statusMessage = 'ERROR';
          this.cdRef.detectChanges();
        });
        this.cdRef.detectChanges();
      });
    }

    this.auth.cast2.subscribe((results: any) => {
      this.contractNumberList = results;
      this.cdRef.detectChanges();
    });
    this.auth.cast3.subscribe((errorMessage: any) => {
      this.errorMessage = errorMessage;
      this.cdRef.detectChanges();
    });
  }

  useAddress(address: any) {
    this.addressRequestList = [];
    this.addressRequest = new AddressRequest();
    this.addressRequest.address = address.streetAddress1;
    this.addressRequest.address2 = address.streetAddress2;
    this.addressRequest.city = address.city;
    this.addressRequest.state = address.state;
    this.addressRequest.zipCode = address.postalCode;
    this.addressRequestList.push(this.addressRequest);
    this.auth.SetAddressData(this.addressRequestList);
    sessionStorage.setItem('addressValid', 'yes');
    this.closeDialog('valid');
  }

  closeDialog(code: any) {
    if (code != 'valid') {
      sessionStorage.removeItem('addressValid');
    }

    this.dialog.closeAll();
  }

  payoffRedirect(e: Event) {
    sessionStorage.setItem('skipterminate', 'yes');
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data: any) => {
      redirect = this.usUrl + data;
    });
    window.location.href = redirect;
  }

  
}

